import {createSvgIcon} from '../create-svg-icon';

export const ChevronLeftIcon = createSvgIcon(
  <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z" />
, 'ChevronLeftOutlined');
